export const APP_BAR_STORE = 'appBarStore'
export const APP_STORE = 'appStore'
export const LOGIN_STORE = 'loginStore'
export const MONITORING_STORE = 'monitoringStore'
export const NAVIGATION_MENU_STORE = 'navigationMenuStore'
export const ROUTING_STORE = 'routingStore'
export const USER_STORE = 'userStore'
export const VIOLATION_LOG_STORE = 'violationLogStore'

export const ALL_STORES = [
    APP_BAR_STORE,
    APP_STORE,
    LOGIN_STORE,
    MONITORING_STORE,
    NAVIGATION_MENU_STORE,
    ROUTING_STORE,
    USER_STORE,
    VIOLATION_LOG_STORE,
]
